import React from "react";
import { Link } from "react-router-dom";
import Binding from "../../../binding";

export default function SearchListItem(props) {
  const created = props.created ? new Date(props.created) : {};
  const lastupdate = props.lastupdate ? new Date(props.lastupdate) : {};
  let binding = new Binding({
    id: props.id,
    entitycode: props.entitycode,
    classcode: props.classcode,
    typecode: props.typecode,
    label: props.label,
  });

  const ItemName = () => (
    <>
      {binding.url ? (
        <Link className="text-dark-50 text-hover-primary" to={`${binding.url}`}>
          {props.label}
        </Link>
      ) : (
        <>{props.label}</>
      )}
    </>
  );

  return (
    <>
      <div className={`row py-4  border-bottom text-dark`}>
        <div
          style={{ wordBreak: "break-all" }}
          className="col-lg-12 m-lg-0 my-3"
        >
          <ItemName />

          <div className="text-dark-75 small mt-1">
            {props.created && (
              <span className="mr-2">Создан: {created.toLocaleString()}</span>
            )}
            {props.lastupdate && (
              <span className="mr-2">
                Изменен: {lastupdate.toLocaleString()}
              </span>
            )}
          </div>
          <div className="text-dark-50 small mt-1">
            {props.areaname && <span className="mr-2">{props.areaname}</span>}
            {props.classlabel && <span>{props.classlabel}</span>}
            {props.typename && (
              <span>
                {props.classlabel && <span className="mx-2">/</span>}
                {props.typename}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
